import Cookies from "js-cookie";
import type { TrackingEvents } from "../events";
import { requestSource } from "./helpers";
import type { TrackingEventOptions, TrackingEventResponse } from "./types";
import { OT_SHOP_TYPE_COOKIE } from "src/utils/constants";
import { pushToDataLayer } from "../googleTagManager";

export async function trackEvent<Key extends keyof TrackingEvents>(
  eventName: Key,
  options?: TrackingEventOptions<Key>
): TrackingEventResponse {
  if (typeof window === "undefined") {
    console.error("trackEvent called in non-client environment");

    return;
  }

  const { props, dataLayerProps, withRequestSource } = options || {};
  const requestSourceValue = withRequestSource ? requestSource() : {};
  const currentShopType = Cookies.get(OT_SHOP_TYPE_COOKIE);

  // Push to dataLayer if dataLayerProps are provided
  if (dataLayerProps) {
    pushToDataLayer(dataLayerProps);
  }

  // If no props (analytics) to send, exit early. Events documented without
  // properties still carry the request source, so they are not skipped here.
  if (Object.keys(props || {}).length === 0 && !withRequestSource) {
    return;
  }

  if (!window.htevents || typeof window.htevents.track !== "function") {
    return;
  }

  try {
    const propsWithShopType = props as { shop_type?: string } | undefined;
    await window.htevents.track(eventName, {
      ...props,
      ...requestSourceValue,
      shop_type: currentShopType || propsWithShopType?.shop_type,
    });
  } catch (error) {
    console.error(`Failed to track event "${eventName}":`, error);
  }
}
